@switch (type) {
    @case ('main') {
        <h4 mat-dialog-title class="modal-title text-center">
            {{ 'SCOREBOARD_HISTORY.MAIN_TITLE' | translate }}
        </h4>
    }
    @case ('teams') {
        <h4 mat-dialog-title class="modal-title text-center">
            {{ 'SCOREBOARD_HISTORY.TEAMS_TITLE' | translate }}
        </h4>
    }
    @case ('defense-received') {
        <h4 mat-dialog-title class="modal-title text-center">
            {{ 'SCOREBOARD_HISTORY.DEF_RECEIVED_TITLE' | translate }}
        </h4>
    }
    @case ('defense-given') {
        <h4 mat-dialog-title class="modal-title text-center">
            {{ 'SCOREBOARD_HISTORY.DEF_GIVEN_TITLE' | translate }}
        </h4>
    }
    @case ('offense') {
        <h4 mat-dialog-title class="modal-title text-center">
            {{ 'SCOREBOARD_HISTORY.OFFENSE_TITLE' | translate }}
        </h4>
    }
}

<mat-dialog-content class="scrollbar">
    <div class="text-center">
        <mat-radio-group color="primary" class="my-5" [ngModel]="yAxisMode" (ngModelChange)="yAxisModeChanged($event)">
            <mat-radio-button class="me-2" value="position">{{ 'STATISTICS.CHARTS_BY_POSITION' | translate }}</mat-radio-button>
            <mat-radio-button value="points">{{ 'STATISTICS.CHARTS_BY_POINTS' | translate }}</mat-radio-button>
        </mat-radio-group>
    </div>
    @if (yAxisMode === 'position') {
        <div class="chart-wrapper">
            <ngx-charts-line-chart
                [xAxis]="true"
                [yAxis]="true"
                [showXAxisLabel]="true"
                [showYAxisLabel]="true"
                [showGridLines]="true"
                [showRefLines]="true"
                [results]="chartData"
                [autoScale]="true"
                [timeline]="true"
                [legend]="true"
                [yAxisLabel]="'STATISTICS.POSITION' | translate"
                [xAxisLabel]="'STATISTICS.DATE' | translate"
                [xAxisTickFormatting]="xAxisTickFormatting"
                [yAxisTickFormatting]="yAxisTickFormattingBinded"
                [curve]="curve"
                [legendTitle]="'STATISTICS.LEGEND' | translate"
            >
                <ng-template #tooltipTemplate let-model="model"> {{ playersCount - model.value }}. {{ model.series }} </ng-template>
                <ng-template #seriesTooltipTemplate let-model="model">
                    {{ model[0]?.name | luxon: 'DATE_SHORT' }}
                    @for (item of model | sortDesc: 'value'; track $index) {
                        <div style="text-align: left">
                            <div>{{ playersCount - item.value }}. {{ item.series }}</div>
                        </div>
                    }
                </ng-template>
            </ngx-charts-line-chart>
        </div>
    } @else if (yAxisMode === 'points') {
        <div class="chart-wrapper">
            <ngx-charts-line-chart
                [xAxis]="true"
                [yAxis]="true"
                [showXAxisLabel]="true"
                [showYAxisLabel]="true"
                [showGridLines]="true"
                [showRefLines]="true"
                [results]="chartData"
                [autoScale]="true"
                [timeline]="true"
                [legend]="true"
                [yAxisLabel]="'STATISTICS.AVG_POINTS' | translate"
                [xAxisLabel]="'STATISTICS.DATE' | translate"
                [xAxisTickFormatting]="xAxisTickFormatting"
                [yAxisTickFormatting]="yAxisTickFormattingBinded"
                [curve]="curve"
                [legendTitle]="'STATISTICS.LEGEND' | translate"
            >
                <ng-template #tooltipTemplate let-model="model"> {{ model.value | number: '1.2-2' }} - {{ model.series }} </ng-template>
                <ng-template #seriesTooltipTemplate let-model="model">
                    {{ model[0]?.name | luxon: 'DATE_SHORT' }}
                    <div style="text-align: left">
                        @for (item of model | sortDesc: 'value'; track $index) {
                            <div>{{ item.value | number: '1.2-2' }} - {{ item.series }}</div>
                        }
                    </div>
                </ng-template>
            </ngx-charts-line-chart>
        </div>
    }
</mat-dialog-content>
<div mat-dialog-actions class="float-right">
    <button mat-button mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
</div>
